import "./features/print.js";
import * as amplify from "./util/amplify.ts";
import * as libLocation from "./lib/location.ts";
import * as modal from "./util/modal.ts";
import * as i18n from "./i18n.ts";
import * as FwDatas from "./FwDatas.ts";
import ApiServer from "./ApiServer.js";
import FizConfig from "./FizConfig.js";
import * as multifamily from "./features/multifamily.js";
import * as login from "./features/login.js";
import * as Html from "./util/Html.ts";
import * as calendar_modal from "./calendar/calendar_modal.js";
import * as renderurl from "./text-renderurl.js";
import * as Handlebars from "./handlebars_family.js";
import * as actionMenu from "./widget/action-menu-registry.ts"
import {OS} from "./lib/os.js"
import Icons from "./svg/Icons.ts"

import "./features/invite.js";
import "./filer/fileViewer.js";
import "./contact/contacts_common.js";
import $ from "./$.js";
import { TaskListCache } from "./server/objects/TaskBeans.ts";
import { ContactCache } from "./contact/ContactCache.js";
import { checkEventLimitOntry, modalEventHardLimitReached } from "./calendar/calendarclean.js";



actionMenu.register({
  feedaction(){
    var 
      object = FwDatas.get(this.metaId())||FwDatas.getWall(this.metaId()),
      menu = [];

    if(object.rights.canDelete){
      menu.push({svg:Icons.ic_delete,onclick:this.attr('data-action-delete'),i18nkey:'actions.delete','color':'var(--red)'})
    }  
    if(object.rights.canUpdate){
      menu.push({svg:Icons.ic_edit,onclick:this.attr('data-action-edit'),i18nkey:'actions.edit'})
    }  
      
    return {menu}  
  },
  taskmenu(){
    return {menu:[
      {svg:Icons.ic_edit,onclick:'taskedit',i18nkey:'task_details.button'},
      {svg:Icons.ic_delete,onclick:'taskdelete',i18nkey:'task_details.deletebutton',color:'var(--red)'}
      ]}
  },
  async eventmenu(){
    var theEvent = FwDatas.get(this.metaId())
    var menu = [];
    var isGoodPage = !theEvent.isTimetableEvent || window.location.toString().indexOf('timetable')>-1;

    if(theEvent.eventType==='BIRTHDAY_ACCOUNT'){
      if(FwDatas.getProfile(theEvent.accountId).isEditable){
        menu.push({svg:Icons.ic_edit,onclick:"modaluser|"+theEvent.accountId,i18nkey:'actions.editsourcebirthdate'})
      }
    }else if(theEvent.eventType==='BIRTHDAY'){
      await ContactCache.need()
      if(ContactCache.get(theEvent.refPersonId)?.editable){
        menu.push({svg:Icons.ic_edit,onclick:"contactedit|"+theEvent.refPersonId,i18nkey:'actions.editsourcebirthdate'})
      }
    }
    if(isGoodPage && theEvent.editable){
      menu.push({svg:Icons.ic_edit,onclick:"eventedit",i18nkey:'actions.edit'})
    }
    menu.push({svg:Icons.ic_duplicate,onclick:"eventduplicate",i18nkey:'actions.copy'})

    if(!theEvent.isTimetableEvent && FwDatas.getFamilies().length>1){
      menu.push({svg:Icons.ic_duplicate_othercircle,onclick:"eventcopy",i18nkey:'actions.copytoanothercircle'})
    }
    if(isGoodPage && theEvent.editable){
      menu.push({svg:Icons.ic_delete,color:'var(--red)',onclick:"deleteevent",i18nkey:'actions.delete'})
    }
    if(OS.canShare){
      menu.push({svg:Icons.ic_send,onclick:"eventshare",i18nkey:'actions.share'})
    }
    menu.push({svg:Icons.ic_download,onclick:"eventdownload",i18nkey:'actions.save'})
    return {menu:menu}
  },
  
})

  
  
  
  ApiServer.customimthreadlist = ApiServer.imthreadlist.prepare(null,false,function(threads){
    var 
      unreadThread = threads.filter(function(thread) {
      return thread.isunRead();
    }).length;
    amplify.publish("notificationBullet","imunreadthread",unreadThread);
    
  });
  
  
  Handlebars.registerHelper('renderMessage',function(text,mode){
    var options = arguments[arguments.length-1];
    if(text){
      var result = renderurl.render($("<div>").text(text.trim()).html(),mode);  
      if(options.fn && result.length){
        return options.fn(new Handlebars.SafeString(result));
      }else{
        return new Handlebars.SafeString(result);
      }
    }else{
      return "";
    }
    
  });
  
  amplify.subscribe ("familyMemberSelected", function(event){
    
    $(".fw-avatar-menu").each(function(idx,obj){
      obj = $(obj);
      // == is on purpose
      var 
        accId,
        onclick = obj.attr("data-fw-onclick");
      if(onclick && onclick.indexOf("familybarselectmember")===0){
        accId = onclick.substring(onclick.indexOf('|')+1);
      }else{
        return;
      }
        
      if(accId==event.selected){
        obj.find('img').addClass('border-branded').removeClass('fw-border-white');
      }else{
        obj.find('img').removeClass('border-branded').addClass('fw-border-white');
      }
    });
  });

  amplify.subscribe ("memberUpdated", function(){
    modal.closeModal();
    libLocation.refresh();
  });
  amplify.subscribe ("refresh", function(){
    libLocation.refresh();
  });

export function notadminmodal(){
  return modal.ask({title:'errors.oopsadminonly',message:'errors.oopsadminonlytext',button:[{title:'actions.gotit',action:'modalclose'}]})
}

Html.register({
  removeparent(){
    this.parent().remove()
    Html.trigger(this,arguments[0],Array.from(arguments).slice(1))
  },
  taskdelete(){
    var 
      node = this.metaIdNode(),
      metaId = node.metaId();

    metaId = FwDatas.get(metaId).taskId;

    modal.confirmDelete('task_details.deleteconfirm',function(){
      modal.closeModal();
      ApiServer.metadelete([metaId]);
      amplify.publish('taskNeedRefresh')
      $('[data-fw-meta-id="'+metaId+'"]').fadeOut();
      
    })
  },
  taskview(taskId){
    var 
      node = this.metaIdNode(),
      metaId = taskId||node.metaId(),
      task = FwDatas.get(metaId),
      currentModal;
    //if instance of task not in cache we display the main
    if(task==null){
      metaId = metaId.substring(0,metaId.lastIndexOf('_'))
      task = FwDatas.get(metaId)
    }
    import("./modal/task_view.mustache").then(function(TPL){
      function ontaskChange(){
        ApiServer.loadTaskAndList(function(lists,listsById,tasks,tasksById,categoryList){
          var isDeleted = tasksById[task.taskId]===undefined;
          if(isDeleted){
            modal.closeModal(currentModal)
          }else{
            //we retake the one of the cache
            //FIXME : it is magic, I dont understand why it works
            task = FwDatas.get(metaId);
            task.justChange = true;
            currentModal = modal.updateModal(currentModal,TPL,task);
            task.justChange = undefined;
          }
        });
        
      }
      if(task && task.list){
        currentModal = modal.openModal(TPL,task,{taskNeedRefresh:ontaskChange}); 
      }else{
        ApiServer.loadTaskAndList(function(){
          currentModal = modal.openModal(TPL,FwDatas.get(metaId),{taskNeedRefresh:ontaskChange}); 
        });  
      }
      
      
    });
  },
  taskedit(){
    var 
      node = this.metaIdNode(),
      metaId = node.metaId();
    modal.closeModal();
    var task = FwDatas.get(metaId);
    if(task && task.taskId!==metaId){
      task = FwDatas.get(task.taskId)
    }    
    import("./modal/task_edit.mustache").then(function(TPL){
      ApiServer.loadTaskAndList(function(){
        if(!task){
          var lists = [].concat(TaskListCache.datas);
          lists.sort((a,b)=>b.lastActionDate - a.lastActionDate)
          task = new ApiServer.types.TaskBean({assignee:[],recurrency:'NONE',taskListId:lists[0].metaId});
        }
        modal.openModal(TPL,{
          task:task
        });
      });  
    });
  },
  taskmark(complete){
    var metaId = this.metaId();
    
    if(metaId.indexOf('_',metaId.indexOf('_')+1)>-1){
      metaId = metaId.substring(0,metaId.indexOf('_',metaId.indexOf('_')+1))
    }
    ApiServer.taskmark.setOptions({progressbar:'none'})(metaId,complete);
    amplify.publish("taskNeedRefresh")
    return false;
  },
  taskmarkimpossible(){
    modal.alert("task_details.markimpossible");
  },
  eventedit(){
    var event = FwDatas.get(this.metaId());
    if(event){
      calendar_modal.editEvent(event)
    }else{
      ApiServer.evtget(this.metaId(),calendar_modal.editEvent);
    }
  },
  async eventduplicate(){
    if(!await checkEventLimitOntry()){
      modalEventHardLimitReached()
      return;
    }
    function doIt(original){
      var
        event = original.cloneWith({metaId:null});
      
      if(original.eventType==='EXTERNAL'){
        event.calendar = null;
        event.toAll = "true";
      }
      if(event.isTimetableEvent){
        event.calendar = original.calendar
      }else{
        let 
          now = new Date();
        while(event.start<now){
          event.start.setDate(event.start.getDate()+7)
          event.end.setDate(event.end.getDate()+7)
        }
      }
      calendar_modal.editEvent(event);
    }
    
    var eventFromCache = FwDatas.get(this.metaId());
    if(eventFromCache){
      doIt(eventFromCache)
    }else{
      ApiServer.evtget(this.metaId(),doIt);
    }
  },
  async eventcreate(){
    var 
      start = new Date(),
      end = new Date();
    start.setMinutes(0)  
    start.setHours(start.getHours()+1);
    end.setMinutes(0);
    end.setHours(start.getHours()+1);
    
    calendar_modal.createEvent(start,end,false);
  },
  
  async modaluser(userId){
    var member = FwDatas.getProfile(parseInt(userId));
    if(member.isAccountDeleted){
      modal.alert("editAccount.memberDeleted");
    }else{
      var TPL = await import("./modal/user_view.mustache")
      modal.openModal(TPL,member) 
    }
    
  },
  async modaluseredit(userId){
    var member = FwDatas.getProfile(parseInt(userId));
    var TPL = await import("./modal/user_edit.mustache")
    modal.openModal(TPL,member);
  },
  selectplace(placeId){
    if(libLocation.getPageName()!='map.php'){
      libLocation.goTo('map.php?placeId='+placeId);
    }else{
      amplify.publish ("placeSelected", placeId);
    }
  },
  userdeletemyself(userId){
    modal.confirmDelete("editAccount.confirmBeforeDeletingFamilyMember",function(){
      amplify.publish('familyChange')
      ApiServer.adminremove(userId,false,function() {
        modal.alert("editAccount.familyMemberDeleted",function(){
          var 
            families = FwDatas.getFamilies(),
            i;
          for(i=0;i<families.length;i++){
            if(families[i].metaId!==FwDatas.getFamily().metaId){
              console.log('try to log on '+families[i].metaId);
              multifamily.changeTo(families[i].metaId);
              return;
            }
          }
          console.log('no other fam => logout');
          
          login.logoutWantedByUser();
          
        });
      });
    });
    
  },
  userdelete(userId){
    modal.confirmDelete("editAccount.confirmBeforeDeletingFamilyMember",function(){
      amplify.publish('familyChange')
      ApiServer.adminremove(userId,false,function() {
        modal.alert("editAccount.familyMemberDeleted",libLocation.refresh);
      });
    });
  },
  async modalcreatecircle(){
    var TPL = await import("./modal/create_circle.mustache")
    modal.openModal(TPL,{});
    
  },
  zoomopen(){
    var zoomable = this.find('.zoomable');
    zoomable.addClass('zoomed');
    document.body.addEventListener('click',()=>{
      zoomable.removeClass('zoomed');
    },{once:true})
  },
  createcirclequotareached(){
    modal.alert({title:"errors.createcirclequotareached",message:i18n.get("errors.createcirclequotareacheddetail",FwDatas.getState().premium.technicalLimiFamilies)});
  },
  invitequotareached(){
    modal.alert({title:"errors.invitequotareached",message:i18n.get("errors.invitequotareacheddetail",FizConfig.invitequota)});
  },
  gotoim(msgAccountId){
    libLocation.goTo("im.php?target="+msgAccountId);
  },
  
  
  selectmember(accountId){
    accountId = accountId||this.data("fw-meta-id")||FwDatas.getAccountId();
    amplify.publish ("familyMemberSelected", {selected: accountId});
  },
  familybarselectmember(accountId){
    accountId = accountId||this.data("fw-meta-id");
    amplify.publish ("familyMemberSelected", {selected: accountId,fromFamilybar:true});
    return false;
  },
  metadelete(confirmTxt,amplifyEventName){
    var
      node = this.metaIdNode(),
      id = node.metaId();
    
    modal.confirmDelete(confirmTxt,function(){
      ApiServer.metadelete([id],function(){
        node.fadeOut("normal", function() {
          $(this).remove();
        });
        if(amplifyEventName){
          amplify.publish(amplifyEventName,id);
        }
      });
    });
  },
  deletecomment(confirmTxt){
    var
      node = this.metaIdNode(),
      id = node.metaId(),
      parentId = node.parent().metaId(),
      commentsNode = $("[data-fw-meta-id='"+parentId+"'] .fw-comments-container").parent();
      
    
    modal.confirmDelete(confirmTxt,function(){
      ApiServer.metadelete(id);
      ApiServer.metaget(parentId,function(metaObject){
        import("./feed/commentsandco.mustache").then(function(TPL){
          Html.setHtml(commentsNode,TPL,metaObject)
        })
        
      })
    });
  },
  deleteevent(){
    var
      id = this.metaId(),
      currentModal = this.parents(".modal").get(0);
    
    function doit(option){
      ApiServer.evtdelete(option,[id],function(){
        amplify.publish("eventDeleted");
        if(currentModal){
          modal.closeModal($(currentModal));
        }
      })
    }

    ApiServer.evtdeleteoption(id,function(options){
      if(options.length<2){
        modal.confirmDelete("event.confirm_delete_event_popup" ,function(){doit(options[0])});
      }else{
        modal.ask({
          title:'event.deleterecurringtitle',
          message:'event.deleterecurringtext',
          button:options.map(opt=>{return {value:opt,title:'event.deleterecurring'+opt}})
        },function(opt){
            if(opt) doit(opt)
        })
      }
    })
  },
  "deletetimetableevent":function(){
    var
      id = this.metaId(),
      currentModal = this.parents(".modal").get(0);
    modal.confirmDelete("event.confirm_delete_event_popup",function(){
      ApiServer.evtdelete("All",id,function(){
        amplify.publish("eventDeleted",id);
        if(currentModal){
          modal.closeModal($(currentModal));
        }
      });
    });  
  },
  async eventshare(){
    try{
      var 
        event = FwDatas.get(this.metaId()),
        url = await ApiServer.evticalvisibleurl(false,event.calendarId,event.metaId);
      
      await navigator.share({url})
    }catch(e){
      modal.oops('fw2.defaultError')
    }
    
  },
  eventdownload(){
    var event = FwDatas.get(this.metaId());
    ApiServer.evticalvisibleurl(false,event.calendarId,event.metaId,function(url){
      var link = document.createElement('a');
      link.download = event.title + ".ics";
      link.textContent = event.title;
      link.href = url;
      link.click()
    })
  },
  alert(text){
    modal.alert(text);
  },
  notadminmodal
  
});


//end of expand controll


//start unstar and comment
ApiServer.modalmetaupdatetext = ApiServer.metaupdatetext.prepare(function(res){
  modal.closeModal();
  res.justUpdated = true;
  if(res instanceof ApiServer.types.IWallMessage){
    wallUiReturn(res);
  }else{
    amplify.publish("CommentChanged")
    commentUiReturn(res);
  }
});

function wallUiReturn(wallMessage){
  import("./feed/default.mustache").then(function(TPL_default){
    Html.setHtml($('#activity-feed div[data-fw-meta-id="'+wallMessage.id+'"]'),TPL_default,wallMessage);
  })
}
function moodWallUiReturn(wallMessage){
  wallMessage.justMooded=true;
  wallUiReturn(wallMessage);
}
function commentUiReturn(comment){
  var 
    commentNode = $('*[data-fw-meta-id="'+comment.commentId +'"]');
  import("./feed/comment.mustache").then(function(TPL_comment){
    Html.replaceWith(commentNode,TPL_comment,comment);
  })
  
}
function moodCommentUiReturn(comment){
  comment.justMooded=true;
  commentUiReturn(comment);
}
Html.register({
  async mediadownload(){
    
    const 
      url = FizConfig.API_BASE_URL+"mediadownload?id="+encodeURIComponent(this.metaId()),
      toast = await modal.toast({emoji:'📁',text:'download.prepare'},0);
    try{
      const 
        resp = await fetch(url,{credentials:"include"}),
        newUrl = window.URL.createObjectURL(await resp.blob()),
        fileName = resp.headers.get("X-File-Name"),
        link = document.createElement('a');
      
      link.href = newUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      
      window.URL.revokeObjectURL(newUrl);
    
    }finally{
      toast.close()
    }


  },
  
  star(){
    var metaId = this.metaId();
    if(metaId.indexOf('Comment')!==-1){
      ApiServer.metamood.noPg()(metaId,["STAR"],moodCommentUiReturn); 
      amplify.publish("CommentChanged") 
    }else{
      ApiServer.wallmood.noPg()(metaId,["STAR"],moodWallUiReturn);  
    }
    
  },
  unstar(){
    var metaId = this.metaId();
    if(metaId.indexOf('Comment')!==-1){
      ApiServer.metamood.noPg()(metaId,[],["STAR"],moodCommentUiReturn); 
      amplify.publish("CommentChanged") 
    }else{
      ApiServer.wallmood.noPg()(metaId,[],["STAR"],moodWallUiReturn);  
    }
   
  },
  edittext(){
    var 
      node = this.metaIdNode(),
      id = node.metaId(),
      type = id.substring(0,id.indexOf('/')),
      titleKey = {wall:'edittext.note',wallComment:'edittext.comment'}[type]||'edittext.default';
    import("./modal/text_edit.mustache").then(function(TPL){
      modal.openModal(TPL,{title:titleKey,metaId:id,text:FwDatas.getWall(id).text});
    });
  },
  copyprevchild(){
    var 
      nodeToCopy = this.get(0).previousElementSibling.firstElementChild;
    
    navigator.clipboard.writeText(nodeToCopy.innerText).then(dunowhat=>{
      modal.toast({svg:Icons.ic_done,text:'invite_link.copied'})
    })
  }
});
ApiServer["custom.checkin"] = function(form,success,error){
  if(form.placeId.value!==''){
    ApiServer.locpublishplacelocation(form,success,error);
  }else{
    ApiServer.locpublishaddress(form,success,error);
  }
}
ApiServer.settingsfeedback = ApiServer.settingsfeedback.prepare(function(){
  modal.closeModal();
  modal.ask({title:'feedback.thanks',message:'feedback.thanksmessage',lottie:"/images/lottie/hugging_face.json",button:[{title:'actions.close',action:'modalclose'}]})
})